import { LucideIcon } from "lucide-react";

export function KpiTile({
  title,
  value,
  subtitle,
  icon: Icon,
  iconColor = "text-blue-400",
}: {
  title: string;
  value: string | number;
  subtitle?: string;
  icon?: LucideIcon;
  iconColor?: string;
}) {
  return (
    <div className="card-dark p-5">
      <div className="flex items-start justify-between mb-2">
        <div className="text-sm text-muted">{title}</div>
        {Icon && <Icon className={`h-5 w-5 ${iconColor}`} />}
      </div>
      <div className="text-3xl font-semibold">{value ?? "—"}</div>
      {subtitle && (
        <div className="mt-1 text-xs flex items-center gap-1 text-green-400">
          {subtitle.startsWith("+") && (
            <svg className="w-3 h-3" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 10l7-7m0 0l7 7m-7-7v18" />
            </svg>
          )}
          {subtitle}
        </div>
      )}
    </div>
  );
}
